// extracted by mini-css-extract-plugin
module.exports = {"SaveElectricC":"C_SaveElectricC__h5dh_"};